import styled from "styled-components";
import Main from "../../../wrappers/Main";

export const Container = styled(Main)``;
